import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import emailjs from '@emailjs/browser'

export const sendEmail = createAsyncThunk('email/sendEmail', async (e, { rejectWithValue }) => {
    try {
        const result = await emailjs.sendForm('service_s3imlj4', 'template_elrtwlr', e.target, '8MDRmya5EAmiPE5Kr')
        if (result.text === 'OK') {
            return { result, e };
        }
        return rejectWithValue('send_failed');
    } catch (error) {
        return rejectWithValue('send_failed');
    }
})

const initialState = { 
    sendEmailSuccess: false,
    sendEmailLoading: false,
    sendEmailError: false
} 

const sendEmailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {

  },
  extraReducers: {
      [sendEmail.pending]: (state) =>{
          return {...state, sendEmailLoading: true, sendEmailSuccess: false, sendEmailError: false}
      },
      [sendEmail.fulfilled]: (state, payload) =>{
        payload?.payload?.e?.target?.reset();
        return {...state, sendEmailLoading: false, sendEmailSuccess: true, sendEmailError: false}
    },
    [sendEmail.rejected]: (state) =>{
        return {...state, sendEmailLoading: false, sendEmailSuccess: false, sendEmailError: true}
    }
  }
})

export default sendEmailSlice.reducer